import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MODULES, ROLE_CLS, ROLE_LABEL } from "@/lib/staff";

const MyAccess = ({ user }) => (
  <div className="rk-glass rounded-2xl p-6" data-testid="my-access">
    <h3 className="text-lg font-bold">Akses Saya</h3>
    <div className="mt-2 flex items-center gap-2 text-sm text-zinc-400">
      <span className="font-mono text-white">{user.username}</span>
      <span className={`rounded px-2 py-0.5 text-[10px] font-bold ${ROLE_CLS[user.role]}`}>{ROLE_LABEL[user.role]}</span>
    </div>
    <ul className="mt-4 space-y-2 text-sm">
      {MODULES.map((m) => {
        const p = user.effective_permissions?.[m.key] || {};
        return (
          <li key={m.key} className="flex justify-between border-b border-white/5 pb-2">
            <span>{m.label}</span>
            <span className={p.manage ? "text-emerald-400" : p.view ? "text-sky-300" : "text-zinc-600"}>
              {p.manage ? "Kelola" : p.view ? "Lihat" : "OFF"}
            </span>
          </li>
        );
      })}
    </ul>
  </div>
);

export const AccountPanel = () => {
  const { user, setToken } = useAuth();
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 6) return toast.error("Password baru minimal 6 karakter");
    if (form.next !== form.confirm) return toast.error("Konfirmasi password tidak sama");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      setToken(data.access_token);
      setForm({ current: "", next: "", confirm: "" });
      toast.success("Password berhasil diganti. Sesi di perangkat lain otomatis keluar.");
    } catch (err) {
      toast.error(errMsg(err, "Gagal ganti password"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="grid gap-5 lg:grid-cols-2" data-testid="account-panel">
      <form onSubmit={submit} className="rk-glass rounded-2xl p-6">
        <h3 className="flex items-center gap-2 text-lg font-bold"><KeyRound size={18} className="text-[#e5b80b]" /> Ganti Password</h3>
        <div className="mt-5 space-y-3">
          <input type="password" value={form.current} onChange={set("current")} placeholder="Password lama" className="rk-input" data-testid="current-password" required />
          <input type="password" value={form.next} onChange={set("next")} placeholder="Password baru (min. 6 karakter)" className="rk-input" data-testid="new-password" required />
          <input type="password" value={form.confirm} onChange={set("confirm")} placeholder="Ulangi password baru" className="rk-input" data-testid="confirm-password" required />
        </div>
        <button type="submit" disabled={busy} className="rk-btn-primary mt-5 text-sm" data-testid="change-password-submit">
          {busy ? <Loader2 size={14} className="animate-spin" /> : "Simpan Password"}
        </button>
      </form>
      <MyAccess user={user} />
    </section>
  );
};
